import { useMemo } from 'react';
import { useComponentTranslations } from 'js/hooks/component';
import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';
import { convertISOToPicker } from 'js/components/common/Fields/DatePicker';

import * as helpers from '../helpers';

export const useValidationConfig = ({ fields, hiddenByRulesFields }) => {
    const translate = useComponentTranslations();

    return useMemo(() => {
        return fields
            .filter((field) => field.validation
                && !field.hideFromUser
                && !field.readOnly
                && (!hiddenByRulesFields || !hiddenByRulesFields.includes(field.name))
            )
            .reduce((config, field) => {
                config[field.name] = helpers.selectValidation(field.validationRules, field);

                switch (field.type) {
                    case FORM_FIELD_TYPE.TEXT:
                    case FORM_FIELD_TYPE.PASSWORD:
                        if (field.requiresConfirmation) {
                            config[`${field.name}_confirmation`] = helpers.selectValidation([
                                { type: 'confirm', field: field.name, message: field.negativeTooltip }
                            ]);
                        }

                        break;

                    case FORM_FIELD_TYPE.DATE_PICKER:
                    case FORM_FIELD_TYPE.DATE_OF_BIRTH: {
                        config[field.name] = [
                            ...config[field.name],
                            ...helpers.selectValidation([{
                                type: 'fn',
                                fn: (value) => {
                                    const { year, month, day } = convertISOToPicker(value);
                                    const dateParts = [year, month, day].map(part => parseInt(part));
                                    const areAllInputsEmpty = dateParts.every(part => isNaN(part));
                                    const areAllInputsFilled = dateParts.every(part => !isNaN(part));

                                    if (areAllInputsEmpty || areAllInputsFilled) {
                                        return null;
                                    }

                                    const errorMessage = field.baseType === FORM_FIELD_TYPE.DATE_PICKER
                                        ? translate('playtech.mobile.system.user.tooltip.datePicker.required')
                                        : translate('playtech.mobile.system.user.tooltip.birthdate.required');

                                    return [errorMessage];
                                }
                            }])
                        ];

                        break;
                    }

                    default:
                        break;
                }
                return config;
            }, {});
    }, [fields, translate, hiddenByRulesFields]);
};
